/**
 * Dot Tabs shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

// set up tabs
import tabs from '../util/tabs';
tabs('dot-tabs', {
	wrap: '.dot-tabs',
	toggles: '.dot-tabs__label',
	content: '.dot-tabs__item',
});

// just pick one random tab at mobile
if(window.matchMedia('(max-width: 800px)').matches){
	const tabs = document.querySelectorAll('.dot-tabs');
	if(tabs){
		tabs.forEach((tab) => {
			const toggles = tab.querySelectorAll('.dot-tabs__label');
			const random = Math.floor(Math.random() * toggles.length);
			toggles[random].click();
		})
	}
}
